import React from 'react';
import { Link } from 'react-router-dom';

const ppLogo = '/ChatGPT Image Aug 11, 2026, 09_22_14 PM.png';

function Footer() {
  return (
    <footer className="footer">
      <span className="footer-logo-frame">
        <img src={ppLogo} alt="The PP Studio" className="footer-logo-img" />
      </span>
      <p>© {new Date().getFullYear()} The PP Studio. Crafted with Precision and Poise.</p>
      <p className="footer-legal">
        <Link to="/sitemap">Site Map</Link> · <Link to="/privacy">Privacy Policy</Link>
      </p>
    </footer>
  );
}

export default Footer;
